import { render, staticRenderFns } from "./PostComments.vue?vue&type=template&id=25cbc1cb&scoped=true"
import script from "./PostComments.vue?vue&type=script&lang=js"
export * from "./PostComments.vue?vue&type=script&lang=js"
import style0 from "./PostComments.vue?vue&type=style&index=0&id=25cbc1cb&prod&lang=css"
import style1 from "./PostComments.vue?vue&type=style&index=1&id=25cbc1cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cbc1cb",
  null
  
)

export default component.exports